<template>
    <form-row title="Is attorney/contract review needed?" section_id="attorney-review">
        <div>
            <input-radio-boolean
                name="needs_attorney_review"
                v-model="needs_attorney_review"
                class="py-1"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <div v-if="needs_attorney_review"
                class="flex flex-col sm:flex-row sm:items-end mt-8"
            >
                <div class="mt-2 sm:-mt-4">
                    <input-date
                        label="Date"
                        name="attorney_review_date"
                        v-model="attorney_review_date"
                        @entered="dateEntered"
                        :read_only="read_only"
                    />
                </div>

                <div class="w-24 sm:pl-6 mt-2 sm:-mt-4">
                    <input-text
                        label="Period"
                        name="attorney_review_period"
                        v-model="attorney_review_period"
                        placeholder="Days"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        attorney: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            attorney_review_period: this.attorney.attorney_review_period,
            needs_attorney_review: this.attorney.needs_attorney_review,
        }
    },

    computed: {
        attorney_review_date: {
            get() {
                return store.state.attorney_review_date || null;
            },
            set(val) {
                store.state.attorney_review_date = val;
            },
        },
        contract_acceptance_date() {
            return store.state.contract_acceptance_date;
        },
        attorney_review_date_from_period() {
            if (! this.contract_acceptance_date) {
                return;
            }

            if (this.isValidDate(this.contract_acceptance_date) && this.attorney_review_period) {
                return dayjs(this.contract_acceptance_date.slice(0, 10))
                    .add({ day: this.attorney_review_period })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.attorney_review_period = null;
        },
    },

    watch: {
        attorney_review_date_from_period(val) {
            if (val) {
                this.attorney_review_date = val;
            }
        },
    },
}
</script>
